module.exports = __webpack_public_path__ + "img/popups-from-the-site.ab1d94b2.webp";